(() => {
  const SHOW_CHAR_MOBILE = 300;
  const ELLIPSES_TEXT = ' ...';
  const MORE_TEXT = 'Show more >';
  const LESS_TEXT = 'Show less';

  const mqlMobile = window.matchMedia('(max-width: 767px)');

  function decodeHtmlEntities(str) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function textToHtmlWithBr(str) {
    return escapeHtml(decodeHtmlEntities(str)).replace(/\n/g, '<br>');
  }

  function renderParagraph(p, state) {
    if (!state) return;

    if (state.expanded) {
      p.innerHTML =
        `${textToHtmlWithBr(state.fullText)} ` +
        `<a href="#" class="about-artwork__toggle">${LESS_TEXT}</a>`;
      return;
    }

    p.innerHTML =
      `${textToHtmlWithBr(state.shortText)}` +
      `<span class="about-artwork__ellipses">${ELLIPSES_TEXT}&nbsp;</span>` +
      `<a href="#" class="about-artwork__toggle">${MORE_TEXT}</a>`;
  }

  function initContainer(container) {
    if (!container || container.__aboutArtworkReadmoreInit) return;
    container.__aboutArtworkReadmoreInit = true;

    const paragraphs = Array.from(container.querySelectorAll('p'));
    paragraphs.forEach((p) => {
      const fullText = decodeHtmlEntities((p.textContent || '').trim());
      if (!fullText) return;
      if (fullText.length <= SHOW_CHAR_MOBILE) return;

      p.__aboutArtworkReadmoreState = {
        fullText,
        shortText: fullText.slice(0, SHOW_CHAR_MOBILE),
        expanded: false,
      };

      renderParagraph(p, p.__aboutArtworkReadmoreState);
    });

    container.addEventListener('click', (event) => {
      const toggle = event.target.closest('a.about-artwork__toggle');
      if (!toggle) return;
      event.preventDefault();

      const p = toggle.closest('p');
      const state = p && p.__aboutArtworkReadmoreState;
      if (!state) return;

      state.expanded = !state.expanded;
      renderParagraph(p, state);
    });
  }

  function initAll() {
    if (!mqlMobile.matches) return;
    document.querySelectorAll('.about-artwork').forEach((c) => initContainer(c));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

